import React, { Component } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Gallery from "./gallerylists/imagesmain";
import SectionFooter from "./sectionfooter";
import "./style/main.css";

class Main extends Component {
  render() {
    return (
      <section id="main">
        <div className="aboutUs">
          <div className="top-gallery-wrapper">
            <ImageGallery
              autoplay={true}
              infinite={true}
              showNav={false}
              showFullscreenButton={false}
              items={Gallery}
              slideInterval={2000}
              onImageLoad={this.handleImageLoad}
            />
          </div>
          <h1>Herzlich Willkommen</h1>

          <p className="intro">
            Seit nunmehr über 100 Jahren sind wir, das Tambour-Korps "Blau-Weiß"
            Hartegasse, durch unsere Auftritte über <br /> die Grenzen der
            Gemeinde Lindlar bekannt geworden.<br />
            Sinn und Zweck des Vereins ist die Pflege der Geselligkeit,<br
            />{" "}
            der Marschmusik sowie der Förderung und Betreuung der Jugend. Das
            Erleben von Gemeinschaft und das herein wachsen in Verantwortung bei
            gemeinsamen Auftritten und bei der Freizeitgestaltung ist die
            Voraussetzung für eine erfolgreiche Vereinsarbeit.<br />
            Mit über 30 Auftritten auf Schützenfesten, privaten Feiern oder an
            den Karnevalstagen sind wir ganzjährig aktiv und präsent. Auch die
            Freizeitgestaltung hat im Tambour-Korps einen hohen Stellenwert.<br
            />
            Neben den schon traditionellen Veranstaltungen, wie unser Wald- und
            Wiesenfest, Familienwandertag, Jugend- und Jahresausflug, sowie der
            Weihnachtsfeier, haben wir auch schon verschiedene mehrtägige Reisen
            unternommen.<br />
            So waren wir bereits zweimal in unserer Partnerstadt Kastella in
            Kroatien, zum europäischen Musikertreffen in San Remo, in Prag und
            in Paris. Und das sind nicht unsere letzten großen Ausflüge gewesen,
            die nächsten sind in Planung.
            <br />Die Förderung und Ausbildung der Jugend, ist ein wichtiger,
            ja, wenn nicht sogar der wichtigste Teil der Vereinsarbeit.
            Interessierte Kinder, Jugendliche und Erwachsene sind immer
            willkommen und werden an der Querflöte, der Lyra oder der
            Marschtrommel nach Noten ausgebildet.
            <br />
            <br />Wir proben jeden Donnerstag von <b>19.30</b> Uhr bis{" "}
            <b>20.30</b> Uhr in der Schule in Süng. Einzelproben finden nach
            Absprache statt.
            <br />
            <br />
            Euer Tambour-Korps "Blau-Weiß" Hartegasse 1912
          </p>
        </div>
        <SectionFooter />
      </section>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/main.js